// OL Finance money helpers — all amounts are integer cents on the wire.
export const toCents = (v) => {
  const n = parseFloat(String(v ?? '').replace(/[^0-9.\-]/g, ''));
  return Number.isFinite(n) ? Math.round(n * 100) : 0;
};
export const fromCents = (c) => ((c || 0) / 100).toFixed(2);
export const money = (c) =>
  `$${((c || 0) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// OL Finance money: positive "$1,234.56", negative "-$1,234.56".
export const fmtMoney = (c) => {
  const n = (c || 0) / 100;
  const s = Math.abs(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return n < 0 ? `-$${s}` : `$${s}`;
};

// ── G1: one app-wide date formatter driven by company settings (default MM/DD/YYYY) ──
let _dateFmt = 'MM/DD/YYYY';
export const setDateFormat = (fmt) => { if (fmt) _dateFmt = fmt; };
export const getDateFormat = () => _dateFmt;

// Accepts an ISO date ('YYYY-MM-DD' or full ISO). Renders per the active company format.
export const fmtDate = (v, fmt) => {
  if (!v) return '';
  const s = String(v);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return s;
  const [, y, mo, d] = m;
  const f = fmt || _dateFmt;
  switch (f) {
    case 'DD/MM/YYYY': return `${d}/${mo}/${y}`;
    case 'YYYY-MM-DD': return `${y}-${mo}-${d}`;
    case 'MM-DD-YYYY': return `${mo}-${d}-${y}`;
    case 'MMM D, YYYY': {
      const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return `${MON[parseInt(mo, 10) - 1]} ${parseInt(d, 10)}, ${y}`;
    }
    default: return `${mo}/${d}/${y}`;   // MM/DD/YYYY
  }
};
